"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableHeaderCell = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TableCell = require("../TableCell/TableCell.styles");
var StyledTableHeaderCell = /*#__PURE__*/(0, _styledComponents.default)(_TableCell.StyledTableCell).withConfig({
  displayName: "StyledTableHeaderCell",
  componentId: "c11n-8-107-0__sc-187oiue-0"
})([""]);
exports.StyledTableHeaderCell = StyledTableHeaderCell;